import { ColumnMappingPlainObject } from './columnMappingBase.plainObject';
import { ParameterValuePlainObject } from './parameter.plainObject';
import { TransformPlainObject } from './transform.plainObject';

export class ExecuteFlowletPlainObject extends TransformPlainObject {
    public composition: string;
    public mappings: Map<number, ColumnMappingPlainObject[]> = new Map<number, ColumnMappingPlainObject[]>();
    public parameters: ParameterValuePlainObject[] = [];
}
